import React, { useState, useEffect } from "react";
import SciFiButton from "./SciFiButton";
import WaitlistModal from "../Home/WaitlistModal";

// Temporary: every "Get 300 credits" button opens the waitlist instead of the app's login
// (this button and the Base card in PlanCardGrid). Set to false to send people to sign up again.
export const WAITLIST_ONLY = true;

const SlidingText = ({ texts }: { texts: string[] }) => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (texts.length <= 1) return;
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % texts.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [texts.length]);

  if (texts.length === 0) return null;
  if (texts.length === 1) {
    return (
      <div className="relative h-[24px] w-full flex items-center justify-center">
        <span className="whitespace-nowrap text-current leading-none pt-0.5">{texts[0]}</span>
      </div>
    )
  }

  return (
    <div className="relative h-[24px] overflow-hidden w-full">
      {texts.map((text, i) => (
        <div
          key={i}
          className="absolute inset-0 flex items-center justify-center w-full transition-all duration-500 ease-in-out"
          style={{
            transform: `translateY(${(i - index) * 100}%)`,
            opacity: i === index ? 1 : 0,
            visibility: Math.abs(i - index) > 1 ? 'hidden' : 'visible'
          }}
        >
          <span className="whitespace-nowrap text-current leading-none pt-0.5">{text}</span>
        </div>
      ))}
    </div>
  );
};

interface GetStartedButtonProps {
  className?: string;
  primaryColor?: string;
  borderColor?: string;
  textColor?: string;
  hoverTextClass?: string;
  texts?: string[];
  onClick?: () => void;
}

const GetStartedButton: React.FC<GetStartedButtonProps> = ({
  className = "",
  primaryColor = "#2F54EB",
  borderColor = "border-zinc-200",
  textColor = "text-[#2F54EB]",
  hoverTextClass = "group-hover:text-white",
  texts = ["Get 300 credits", "Start for free"],
  onClick
}) => {

  const [waitlistOpen, setWaitlistOpen] = useState(false);
  // Mounted on the first click only: the modal looks up the visitor's location when it mounts,
  // and a page can carry several of these buttons.
  const [waitlistMounted, setWaitlistMounted] = useState(false);

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else if (WAITLIST_ONLY) {
      setWaitlistMounted(true);
      setWaitlistOpen(true);
    } else {
      window.location.href = "https://app.monet.io/login?planId=prod_TxAlKaATCscbCB";
    }
  };

  return (
    <>
      <SciFiButton
        className={className}
        primaryColor={primaryColor}
        initialBorderColor={borderColor}
        textColor={textColor}
        hoverTextClass={hoverTextClass}
        onClick={handleClick}
      >
        <SlidingText texts={texts} />
      </SciFiButton>
      {waitlistMounted && <WaitlistModal open={waitlistOpen} setOpen={setWaitlistOpen} />}
    </>
  );
};

export default GetStartedButton;
